import React from "react";

export default function ReportPanel({
  runId,
  runState,
  onDownloadPDF,
  outputContract,
  isDownloading,
  canDownloadPdf,
  userPlan,
}) {
  const interpretation = outputContract?.interpretation || {};

  const exclusions = outputContract?.exclusions || [];
  const excludedCount = interpretation.excluded_count ?? exclusions.length;

  const governedCount = interpretation.governed_count ?? 0;
  const totalRecords = interpretation.total_records ?? 0;

  const isReportAvailable =
    outputContract &&
    (runState === "locked" || runState === "exported");

  const isDownloadAllowed =
    isReportAvailable &&
    canDownloadPdf &&
    !!runId &&
    !isDownloading;

  return (
    <section
      style={{
        marginTop: 20,
        padding: 24,
        borderRadius: 14,
        border: "1px solid #e0e6f0",
        background: "#ffffff",
      }}
    >
      <h3 style={{ marginTop: 0 }}>Review & Report</h3>
      <p style={{ color: "#5f6f86", marginTop: 0 }}>
        Lock the run and generate the official project report.
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 20,
          gap: 20,
          flexWrap: "wrap",
        }}
      >
        <div>
          <p style={{ margin: "0 0 8px 0" }}>
            <strong>Status:</strong>{" "}
            {runState === "locked" || runState === "exported"
              ? "LOCKED"
              : runState || "N/A"}
          </p>

          <p style={{ margin: "0 0 8px 0" }}>
            <strong>Data coverage:</strong>{" "}
            {totalRecords > 0
              ? `${governedCount} / ${totalRecords} records matched`
              : "No records processed"}
          </p>

          <p style={{ margin: 0 }}>
            <strong>Total A1-A3:</strong>{" "}
            {Number(outputContract?.summary?.total_kg_co2e || 0).toFixed(2)} kgCO₂e
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
          <button
            onClick={onDownloadPDF}
            disabled={!isDownloadAllowed}
            style={{
              backgroundColor: isDownloadAllowed ? "#28a745" : "#cccccc",
              color: "#ffffff",
              border: "none",
              padding: "12px 18px",
              borderRadius: 8,
              cursor: isDownloadAllowed ? "pointer" : "not-allowed",
              fontWeight: 700,
            }}
          >
            {isDownloading
              ? "Downloading..."
              : canDownloadPdf
              ? "Download PDF Report"
              : "Upgrade to download PDF"}
          </button>

          {!canDownloadPdf && (
            <div
              style={{
                marginTop: 8,
                fontSize: 12,
                color: "#9a3412",
                fontWeight: 600,
              }}
            >
              Available on Professional and Enterprise plans. Current plan: {userPlan || "trial"}
            </div>
          )}
        </div>
      </div>

      {!isReportAvailable && (
        <p style={{ marginTop: 16 }}>
          Report becomes available after locking the run.
        </p>
      )}
    </section>
  );
}